export default {
  APPLICANT: 'APPLICANT',
  ENROLLMENT: 'ENROLLMENT',
} as const;